module.exports = __webpack_public_path__ + "static/media/background_default_compressed.ec04d1bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/background_default_compressed.jpg
// module id = 1705
// module chunks = 3